import { render, staticRenderFns } from "./step_4.vue?vue&type=template&id=ae20cb12&scoped=true&"
import script from "./step_4.vue?vue&type=script&lang=js&"
export * from "./step_4.vue?vue&type=script&lang=js&"
import style0 from "./step_4.vue?vue&type=style&index=0&id=ae20cb12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae20cb12",
  null
  
)

export default component.exports